import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useCustomer } from "@/lib/customerAuth";
import { formatErr } from "@/lib/api";
import { LogIn, Mail, Lock } from "lucide-react";

export default function Login() {
  const { login, signIn } = useCustomer();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/my-bookings";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav(next);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Sign in failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold text-center">Customer login</div>
      <h1 className="font-display text-4xl uppercase mt-2 text-center">Sign in</h1>
      <p className="text-sm text-[#555] text-center mt-3">Access your booking history and re-book faster.</p>

      <form onSubmit={submit} className="ff-card p-8 mt-8 space-y-4" data-testid="login-form">
        <div>
          <label className="text-xs uppercase tracking-widest text-[#666] font-bold">Email</label>
          <div className="relative mt-1">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="ff-input pl-9" data-testid="login-email" />
          </div>
        </div>
        <div>
          <div className="flex justify-between items-baseline">
            <label className="text-xs uppercase tracking-widest text-[#666] font-bold">Password</label>
            <Link to="/forgot-password" className="text-xs uppercase tracking-widest text-[#D71920] hover:underline" data-testid="forgot-link">Forgot?</Link>
          </div>
          <div className="relative mt-1">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="ff-input pl-9" data-testid="login-password" />
          </div>
        </div>
        <button type="submit" disabled={busy} className="ff-btn-primary w-full" data-testid="login-submit">
          <LogIn className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <div className="relative my-6 text-center">
        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-[#e5e5e5]" /></div>
        <span className="relative bg-white px-3 text-xs uppercase tracking-widest text-[#999]">Or</span>
      </div>
      <button onClick={signIn} className="w-full border-2 border-[#111] px-6 py-3 text-sm uppercase tracking-widest font-bold hover:bg-[#111] hover:text-white transition" data-testid="google-signin">
        Sign in with Google
      </button>

      <p className="text-center text-sm text-[#555] mt-6">
        New to Forkfix? <Link to="/register" className="text-[#D71920] font-bold hover:underline" data-testid="go-register">Create an account</Link>
      </p>
    </div>
  );
}
